import { render, staticRenderFns } from "./SettingsInformation.vue?vue&type=template&id=311a807c"
import script from "./SettingsInformation.vue?vue&type=script&lang=js"
export * from "./SettingsInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports